export default {
    pluginName: 'merger',
    backendDataType: 'MA',
    rowIdKey: 'DOC_ID',
    edit: 'data_edit',
    count: 'ma_count',
    totalCount: 'total_ma_count',
    fieldI18nKey: 'commonMerger',
    maxPerFolder: 'max_ma_per_folder',
    maxOp: 'max_op_ma',
    staticFields: ['TITLE'],
    dataId: 'ID',
};
